export function clearStaleInteractionStatus(clientId: string) {
  if (typeof window === "undefined") {
    return;
  }

  const keysToRemove: string[] = [];
  for (let i = 0; i < window.localStorage.length; i += 1) {
    const key = window.localStorage.key(i);
    if (!key?.endsWith(".interaction.status")) {
      continue;
    }

    const value = window.localStorage.getItem(key);
    if (!value) {
      keysToRemove.push(key);
      continue;
    }

    try {
      const parsed = JSON.parse(value) as { clientId?: string };
      if (!parsed.clientId || parsed.clientId === clientId) {
        keysToRemove.push(key);
      }
    } catch {
      keysToRemove.push(key);
    }
  }

  for (const key of keysToRemove) {
    window.localStorage.removeItem(key);
  }
}
